import { Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { SharedConsts } from 'src/app/shared/constants';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { SharedService } from 'src/app/shared/services/shared.service';


@Injectable({
  providedIn: 'root'
})
export class StatePersistService {
  private storageSub= new Subject<string>();
  private searchStorageSub = new Subject<string>();
  private addressStorageSub = new Subject<string>();
  private globaldataStorageSub = new Subject();
  private retailerStorageSub = new Subject<string>();
  private categoryStorageSub = new Subject<string>();
  private productStorage = new Subject();
  private productDetaileStorage = new Subject();
  private PromotionProductsStorage = new Subject();
  private PromotionStorage = new Subject()
  private recommendedProductsStorage = new Subject();
  private newProductsStorage = new Subject();
  private homepageRecommendedProductsStorage = new Subject();
  private homepagePromotionProductsStorage = new Subject();

  public passProductID$ = this.productStorage.asObservable();

  private minicartStorage = new BehaviorSubject({});
  miniCartObjectObser = this.minicartStorage.asObservable();

  private suggestedProductStorage = new Subject();
  private homePageStorage = new Subject();
  private storeListingStorage = new Subject();
  private selectedStoreStorage = new Subject();
  private reorderStorage = new Subject();
  private categoryDetailStorage = new Subject();
  private myorderStorage = new Subject();
  private minicartChangeStorage = new Subject();
  private outOfStockStorage = new Subject();
  private backInStockStorage = new Subject();
  private myCartStorage = new Subject();
  private orderDetailStorage = new Subject();
  private mobileListCountStorage = new Subject();
  private userLoginDataStorage = new Subject();
  private categoryMessageSource = new BehaviorSubject<string>('service');
  currentMessage = this.categoryMessageSource.asObservable();
  configDetails:any={};
  checkoutToken: any = '';
  public isConfigSetoStore = new BehaviorSubject(false);
  getConfigStatus = this.isConfigSetoStore.asObservable();

  constructor(private googleAnalyticsService: GoogleAnalyticsService, private sharedService: SharedService,private sanitizer: DomSanitizer
    ) { }

  emitCategoryMessage(message: string) {
    this.categoryMessageSource.next(message)
  }


  watchCategoryMessage(): Observable<any> {
    return this.categoryMessageSource.asObservable();
  }

  watchStorage(): Observable<any> {
    return this.storageSub.asObservable();
  }

  watchHomePageStorage(): Observable<any> {
    return this.homePageStorage.asObservable();
  }

  watchStoreListing(): Observable<any> {
    return this.storeListingStorage.asObservable();
  }

  watchStoreSelected(): Observable<any> {
    return this.selectedStoreStorage.asObservable();
  }

  watchReorderStorage(): Observable<any> {
    return this.reorderStorage.asObservable();
  }

  watchcategoryDetailStorage(): Observable<any> {
    return this.categoryDetailStorage.asObservable();
  }

  watchmyorderStorage(): Observable<any> {
    return this.myorderStorage.asObservable();
  }

  watchmobileListCountStorage(): Observable<any> {
    return this.mobileListCountStorage.asObservable();
  }

  watchMiniCartDetail(): Observable<any> {
    return this.minicartStorage.asObservable();
  }

  watchSuggestedPRoductListing(): Observable<any> {
    return this.suggestedProductStorage.asObservable();
  }

  watchMiniCartDetailChange(): Observable<any> {
    return this.minicartChangeStorage.asObservable();
  }

  watchOtOfStockDetail(): Observable<any> {
    return this.outOfStockStorage.asObservable();
  }

  watchbackInStockDetail(): Observable<any> {
    return this.backInStockStorage.asObservable();
  }

  watchMyCartDetail(): Observable<any> {
    return this.myCartStorage.asObservable();
  }

  watchMyOrderDetail(): Observable<any> {
    return this.orderDetailStorage.asObservable();
  }

  watchProductPageStorage(): Observable<any> {
    return this.productStorage.asObservable();
  }

  watchProductDetailPageStorage(): Observable<any> {
    return this.productDetaileStorage.asObservable();
  }

  watchPromotionProductsStorage(): Observable<any> {
    return this.PromotionProductsStorage.asObservable();
  }

  watchPromotionStorage(): Observable<any> {
    return this.PromotionStorage.asObservable();
  }

  watchNewProductsStorage(): Observable<any> {
    return this.newProductsStorage.asObservable();
  }

  watchhomepageRecommendedProductsStorage(): Observable<any> {
    return this.homepageRecommendedProductsStorage.asObservable();
  }

  watchhomepagePromotionProductsStorage(): Observable<any> {
    return this.homepagePromotionProductsStorage.asObservable();
  }

  

  watchRecommendedProductsStorage(): Observable<any> {
    return this.recommendedProductsStorage.asObservable();
  }

  

  emithomepageDetails(data){
    this.homePageStorage.next(data)
  }

  emitstoreListing(data){
    this.storeListingStorage.next(data)
  }
  

  emitSelectedStore(data){
    this.selectedStoreStorage.next(data)
  }

  emitreorderDetails(data){
    this.reorderStorage.next(data)
  }

  emitcategoryDetails(data){
    this.categoryDetailStorage.next(data)
  }


  emitmyorderDetails(data){
    this.myorderStorage.next(data)
  }

  emitmobileListCountDetails(data){
    this.mobileListCountStorage.next(data)
  }

  emitOrderDetailData(data) {
    this.orderDetailStorage.next(data);
  }

  emitmyCartData(data) {
    this.myCartStorage.next(data);
  }

  emitoutOfStockData(data) {
    this.outOfStockStorage.next(data);
  }

  emitbackInStockData(data) {
    this.backInStockStorage.next(data);
  }

  emitProductData(data) {
    this.productStorage.next(data);
  }

  emitProductDetailData(data) {
    this.productDetaileStorage.next(data);
  }

  emitrecommendedProductsData(data){
    this.recommendedProductsStorage.next(data);
  }

  emitPromotionProductsData(data){
    this.PromotionProductsStorage.next(data);
  }
  emitPromotionsData(data){
    this.PromotionStorage.next(data)
  }

  emitNewProductsData(data){
    this.newProductsStorage.next(data);
  }

  emithomepageRecommendedProductsData(data){
    this.homepageRecommendedProductsStorage.next(data);
  }

  emithomepagePromotionProductsData(data){
    this.homepagePromotionProductsStorage.next(data);
  }

  emitminiCartData(data) {
    this.minicartStorage.next(data);
  }

  emitSuggestedProductListData(data){
    this.suggestedProductStorage.next(data);
  }

  emitminiCartDataChange(data) {
    this.minicartChangeStorage.next(data);
  }

  emitUserLoginData(data){
    this.userLoginDataStorage.next(data);
  }

  watchUserDetailChange(): Observable<any> {
    return this.userLoginDataStorage.asObservable();
  }

  watchSearchStorage(): Observable<any> {
    return this.searchStorageSub.asObservable();
  }

  watchCategoryStorage(): Observable<any> {
    return this.categoryStorageSub.asObservable();
  }

  watchAddressStorage(): Observable<any> {
    return this.addressStorageSub.asObservable();
  }

  watchGlobalDataStorage(): Observable<any> {
    return this.globaldataStorageSub.asObservable();
  }

  

  watchRetailerStorage(): Observable<any> {
    return this.retailerStorageSub.asObservable();
  }

  public setSesion(token: string, data: any) {
    sessionStorage.setItem(token, JSON.stringify(data));
  }

  public getSesion(token: string) {
    return JSON.parse(sessionStorage.getItem(token));
  }

  public removeSesion(token: string) {
    sessionStorage.removeItem(token);
  }

  public setLocalStorage(token: string, data: any, from? : any, sync? :any) {
    localStorage.setItem(token, JSON.stringify(data));
      if(token == 'product_data' && from == 'product-data-update'){
        this.storageSub.next('added');
      }
      

      if(token == 'currentUser' && from == 'user_update'){
        this.userLoginDataStorage.next('added');
      }
  
      if(token == 'product_data' && from == 'search'){
        this.searchStorageSub.next('added');
      }
  
      if(token == 'global_data'){
        this.globaldataStorageSub.next('added');
      }

      if(token == 'address-disabled'){
        this.addressStorageSub.next('added');
      }

      if(token == 'retailer-disabled'){
        this.retailerStorageSub.next('added');
      }

      if(token == 'selected_category' && from !== 'category'){
        this.categoryStorageSub.next('added')
      }

      if(token == 'mini_cart_details' && from == 'change'){
        this.minicartChangeStorage.next('added')
      }
      
    
  }

  public getLocalStorage(token: string) {
    if (localStorage.getItem(token) !== "undefined"){
      return JSON.parse(localStorage.getItem(token));
    }
    return ''
  }

  public removeLocalStorage(token: string) {
    localStorage.removeItem(token);
  }

  public amendQtyGoogleanalyticsEvent() {
    var currentuser = this.getLocalStorage('currentUser')
    if (currentuser.is_telesales_user || currentuser.is_sales_rep || currentuser.is_head_office_user){
      this.googleAnalyticsService.eventEmitter("basket_amend_qty", SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, "basket amend quantity", SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    }
    else{
      this.googleAnalyticsService.eventEmitter("basket_amend_qty_cart", SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, "basket amend quantity", SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    }
  }

  //----------helper method for Image Safe Url 
    getSafeUrl(imageUrl:string):SafeUrl{
    let url = this.sanitizer.bypassSecurityTrustUrl(imageUrl);
    return url
  }
}
